<template>
    <div v-show="!hidden" class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
        <div
            :class="{ 'bg-green-100': messageType == 'success', 'bg-red-100': messageType == 'error' }"
            x-transition:enter="transform ease-out duration-300 transition"
            x-transition:enter-start="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            x-transition:enter-end="translate-y-0 opacity-100 sm:translate-x-0"
            x-transition:leave="transition ease-in duration-100"
            x-transition:leave-start="opacity-100"
            x-transition:leave-end="opacity-0"
            class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
        >
            <div class="rounded-lg shadow-xs overflow-hidden">
                <div class="p-4">
                    <div class="flex items-start">
                        <div class="flex-shrink-0">
                            <svg v-if="messageType == 'success'" class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <svg
                                v-if="messageType == 'error'"
                                class="h-6 w-6 text-red-400"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <div class="ml-3 w-0 flex-1 pt-0.5">
                            <p class="text-sm leading-5 font-medium text-gray-900">
                                {{ messageBody }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['message', 'type'],

    data() {
        return {
            messageBody: null,
            messageType: 'success',
            hidden: true,
        }
    },

    created() {
        if (this.message) {
            this.flash(this.message, this.type)
        }

        Bus.$on('flash', (message, type) => {
            if (typeof type === 'undefined') {
                type = 'success'
            }

            this.flash(message, type)
        })
    },

    methods: {
        flash(message, type) {
            this.messageBody = message
            this.messageType = type
            this.hidden = false

            this.hide()
        },

        hide() {
            setTimeout(() => {
                this.hidden = true
            }, 5000)
        },
    },
}
</script>
